<template>
  <div @click="$emit('click')" :class="containerClasses">
    <img :src="_src" :alt="alt" class="avatar" :style="style" />
    <p v-if="text" class="description mt-2 mb-0">{{ text }}</p>
  </div>
</template>
<script>
export default {
  props: {
    src: String,
    alt: String,
    text: String,
    size: {
      type: String,
      default: "50"
    },
    button: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    _src() {
      return this.src || require("@/assets/img/default-avatar.png");
    },
    style() {
      const { size } = this;
      return `width: ${size}px; height: ${size}px;`;
    },
    containerClasses() {
      const classes = ["avatar-container"];
      if (this.button) classes.push("is-button");
      if (this.active) classes.push("is-active");
      return classes.join(" ");
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../assets/sass/now-ui-dashboard/variables";

$active-color: $info-color;

.avatar-container {
  display: inline-block;
  text-align: center;

  &.is-button {
    cursor: pointer;
  }

  &.is-active {
    .avatar {
      border-color: $active-color;
    }

    .description {
      color: $active-color;
    }
  }
}

.avatar {
  vertical-align: middle;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin: 0;
  object-fit: cover;
  border: 3px solid rgba(0, 0, 0, 0.16);
}
</style>
